import { render, staticRenderFns } from "./v-small-popup.vue?vue&type=template&id=420400d8&scoped=true"
import script from "./v-small-popup.vue?vue&type=script&lang=js"
export * from "./v-small-popup.vue?vue&type=script&lang=js"
import style0 from "./v-small-popup.vue?vue&type=style&index=0&id=420400d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../com-tool/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420400d8",
  null
  
)

export default component.exports